import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { useIntl } from 'gatsby-plugin-intl'
import styled from 'styled-components'

import MethodsCarousel from '../methodsCarousel'
import Method from './method'
import Btn from '../../common/button'

import { usePaymentsContext } from '../../../context/paymentProvider'
import { PaymentTypes } from '../../../utils/constants'
import storageService from '../../../services/storageService'
import { EnvConfig } from '../../../config/EnvConfig'
import { resendActivationEmail } from '../../../adapters/user'
import toast from '../../common/toast'

const Message = styled.div`
  text-align: center;
  padding: 2rem 0;
`

const Withdraw = ({ onClose }) => {
  const intl = useIntl()
  const user = storageService.getUser()

  const { currentMethod } = usePaymentsContext()

  const data = useStaticQuery(graphql`
    {
      paymentsApi {
        values {
          lang
          methods {
            enabled
            payment_code
            payment_name
            payment_details {
              maximum_amount
              minimum_amount
              player_currency
              type_of_payment
              order_number
              customer_information_text
              country_of_registration
              default_amounts {
                amount
              }
              logo {
                height
                width
                url
                alt
              }
            }
          }
        }
      }
    }
  `)

  const getWithdrawPayments = (details) => {
    return details.filter(
      (row) => row.type_of_payment === PaymentTypes.WITHDRAW
    )[0]
  }

  const resendEmailActivation = async () => {
    const response = await resendActivationEmail(
      user.email,
      `${EnvConfig.SITE_URL}/activate/`
    )

    if (response.ok)
      toast.success(intl.formatMessage({ id: 'account.resendEmailSuccess' }))
  }

  const {
    paymentsApi: { values },
  } = data

  const dataExistForLocale = values.some((row) => row.lang === intl.locale)
  const dataExistForPage =
    dataExistForLocale &&
    values.filter((row) => row.lang === intl.locale)[0].methods.length > 0
  const methods = dataExistForPage
    ? values
        .filter((row) => row.lang === intl.locale)[0]
        .methods.filter(
          (row) => row.enabled && getWithdrawPayments(row.payment_details)
        )
    : []

  return (
    <>
      {methods.length > 0 &&
        user.user_status.name.toLowerCase() !== 'pending' && (
          <MethodsCarousel methods={methods} />
        )}

      {currentMethod && user.user_status.name.toLowerCase() !== 'pending' && (
        <Method withdrawClose={onClose} />
      )}

      {methods.length === 0 &&
        user.user_status.name.toLowerCase() !== 'pending' && (
          <Message>
            {intl
              .formatMessage({ id: 'account.paymentMethodsNotAvailable' })
              .replace('{0}', user.wallet.currency.short_code)}
          </Message>
        )}

      {(user.user_status.name.toLowerCase() === 'pending' ||
        !user.user_status.deposit_enabled) && (
        <Message>
          {intl.formatMessage({ id: 'account.not-verified' })}

          <Btn
            text={intl.formatMessage({ id: 'account.resend-email' })}
            bgcolor='#31c27c'
            padding='.32rem 1rem'
            bordercolor='#31c27c'
            fontSize='.85em'
            onClick={resendEmailActivation}
          />
        </Message>
      )}
    </>
  )
}

export default Withdraw
